// ============================================
// Google Partner Ajans - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const googlePartnerAjansContent: BlogContent = {
  tableOfContents: [
    { id: "partner-nedir", title: "Google Partner Nedir?" },
    { id: "partner-avantajlari", title: "Partner Avantajları" },
    { id: "ajans-secimi", title: "Partner Ajans Seçimi" },
    { id: "sertifikasyon", title: "Sertifikasyon Süreci" },
    { id: "premier-partner", title: "Premier Partner Farkı" },
    { id: "dogrulama", title: "Partner Statüsü Doğrulama" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>Google Partner ajans</strong> ile çalışmanın avantajlarını ve seçim kriterlerini öğrenin. <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">18 yıllık Google Ads deneyimi</a> ile Google Partner programı, avantajları ve doğru ajans seçimi hakkında kapsamlı rehber."
    },
    { type: "heading", value: "Google Partner Programı Nedir?", id: "partner-nedir" },
    {
      type: "paragraph",
      value: "<strong>Google Partner</strong>, Google'ın dijital pazarlama ajansları ve uzmanları için oluşturduğu resmi sertifikasyon ve rozet programıdır. Google Partners, Google Ads konusunda uzmanlığını kanıtlamış ve belirli performans standartlarını karşılayan şirketlerdir."
    },
    {
      type: "subheading",
      value: "Google Partner Badge'in Anlamı"
    },
    {
      type: "paragraph",
      value: "Google Partner badge'i almış bir ajans veya uzman, aşağıdaki gereksinimleri karşılamıştır:"
    },
    {
      type: "list",
      items: [
        "<strong>Performans:</strong> Son 90 günde yönettikleri hesaplarda $10,000+ ad spend",
        "<strong>Sertifikasyon:</strong> En az 1 Google Ads sertifikalı uzman",
        "<strong>Optimization Score:</strong> En az %70 optimization score",
        "<strong>Ad Spend Growth:</strong> Müşteri hesaplarında sürdürülebilir büyüme",
        "<strong>Retention:</strong> En az %50 müşteri retention oranı"
      ]
    },
    {
      type: "subheading",
      value: "Google Partner vs Premier Partner"
    },
    {
      type: "table",
      caption: "Google Partner Program Seviyeleri Karşılaştırması",
      headers: ["Kriter", "Google Partner", "Premier Partner"],
      rows: [
        ["<strong>90 Günlük Ad Spend</strong>", "$10,000+", "$150,000+"],
        ["<strong>Sertifikalı Uzman</strong>", "En az 1", "En az 2"],
        ["<strong>Optimization Score</strong>", "%70+", "%70+"],
        ["<strong>Company Size</strong>", "Tüm boyutlar", "Genellikle büyük ajanslar"],
        ["<strong>Google Support</strong>", "Standart", "Priority support"],
        ["<strong>Beta Özelliklere Erişim</strong>", "Sınırlı", "Öncelikli erişim"],
        ["<strong>Badge Rengi</strong>", "Mavi", "Kırmızı"],
        ["<strong>Specialization Badges</strong>", "Evet", "Evet"]
      ]
    },
    {
      type: "subheading",
      value: "Specialization Badges (Uzmanlık Rozetleri)"
    },
    {
      type: "paragraph",
      value: "Google Partner ajanslar ayrıca belirli kampanya tiplerinde uzmanlıklarını gösteren specialization badges alabilirler:"
    },
    {
      type: "list",
      items: [
        "<strong>Search Advertising:</strong> Arama reklamları uzmanlığı ($5,000+ spend, %5+ CTR)",
        "<strong>Display Advertising:</strong> Display reklamları uzmanlığı ($2,500+ spend)",
        "<strong>Video Advertising:</strong> YouTube ve video reklamları ($2,500+ spend)",
        "<strong>Shopping Advertising:</strong> Google Shopping kampanyaları ($5,000+ spend)",
        "<strong>Apps Advertising:</strong> Mobil uygulama reklamları ($2,500+ spend)",
        "<strong>Search Engine Marketing:</strong> Cross-channel arama pazarlama stratejileri"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Önemli:</strong> Her specialization badge için ayrı performans kriterleri vardır. Bir ajansın sadece Partner badge'i olması, her kampanya tipinde uzman olduğu anlamına gelmez. Specialization badges'leri mutlaka kontrol edin."
    },
    { type: "heading", value: "Google Partner Ajans ile Çalışmanın Avantajları", id: "partner-avantajlari" },
    {
      type: "subheading",
      value: "1. Kanıtlanmış Uzmanlık ve Deneyim"
    },
    {
      type: "list",
      items: [
        "<strong>Sertifikasyon Kanıtı:</strong> Google Ads platformunda test edilmiş bilgi",
        "<strong>Minimum Performans Standartları:</strong> %70+ optimization score gereksinimi",
        "<strong>Sürekli Eğitim:</strong> Yeni özellikler ve best practices konusunda güncel kalma",
        "<strong>Audit Edilmiş Süreçler:</strong> Google tarafından düzenli olarak değerlendirilen performans"
      ]
    },
    {
      type: "subheading",
      value: "2. Google'dan Doğrudan Destek ve Kaynaklar"
    },
    {
      type: "list",
      items: [
        "<strong>Google Support:</strong> Partner ajanslar Google temsilcilerine daha kolay erişim sağlar",
        "<strong>Beta Özellikler:</strong> Yeni Google Ads özelliklerine erken erişim (Premier Partner için daha fazla)",
        "<strong>Training Resources:</strong> Özel eğitim materyalleri ve webinarlar",
        "<strong>Partner Community:</strong> Diğer partner ajanslarla networking ve best practice paylaşımı",
        "<strong>Technical Support:</strong> Kompleks kampanya kurulumları için Google'dan teknik destek"
      ]
    },
    {
      type: "subheading",
      value: "3. İleri Seviye Araçlar ve İçgörüler"
    },
    {
      type: "list",
      items: [
        "<strong>Partner Dashboards:</strong> Performans tracking için özel dashboardlar",
        "<strong>Benchmark Data:</strong> Sektör performans karşılaştırmaları",
        "<strong>Custom Reports:</strong> Gelişmiş raporlama araçları",
        "<strong>Optimization Recommendations:</strong> Google'ın AI-powered önerileri",
        "<strong>Audience Insights:</strong> Detaylı hedef kitle analizleri"
      ]
    },
    {
      type: "subheading",
      value: "4. Güvenilirlik ve Hesap Verebilirlik"
    },
    {
      type: "list",
      items: [
        "<strong>Google Onayı:</strong> Google tarafından onaylanmış ve rozet almış ajans",
        "<strong>Minimum Standards:</strong> Belirli kalite standartlarını karşılama zorunluluğu",
        "<strong>Performance Monitoring:</strong> Google tarafından düzenli performans izleme",
        "<strong>Badge Renewal:</strong> Yıllık renewal için sürekli performans gereksinimi",
        "<strong>Customer Satisfaction:</strong> En az %50 retention oranı şartı"
      ]
    },
    {
      type: "subheading",
      value: "5. Kredibilite ve Güven"
    },
    {
      type: "list",
      items: [
        "<strong>Third-Party Validation:</strong> Google'ın resmi onayı",
        "<strong>Public Directory:</strong> Google Partners directory'de listeleme",
        "<strong>Marketing Collateral:</strong> Partner badge'ini website ve materyallerde kullanma hakkı",
        "<strong>Competitive Edge:</strong> Partner olmayan ajanslardan ayrışma"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Gerçek Dünya Değeri:</strong> <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">18 yıllık deneyimimle</a> gözlemlediğim kadarıyla, Google Partner ajanslar ortalama %20-30 daha iyi performans gösterir. Bunun sebebi sadece badge değil, badge almak için gereken sürekli eğitim ve performans optimizasyonu kültürüdür."
    },
    { type: "heading", value: "Google Partner Ajans Seçim Kriterleri", id: "ajans-secimi" },
    {
      type: "paragraph",
      value: "Google Partner badge önemli bir kriter ama yeterli değildir. İşte ek olarak kontrol etmeniz gerekenler:"
    },
    {
      type: "subheading",
      value: "1. Partner Statüsü Doğrulama"
    },
    {
      type: "list",
      items: [
        "<strong>Google Partners Directory:</strong> partners.google.com adresinden ajansı arayın",
        "<strong>Badge Gösterimi:</strong> Ajansın websitesinde resmi badge var mı?",
        "<strong>Specialization Badges:</strong> Hangi specialization badges'lere sahip?",
        "<strong>Premier Partner Status:</strong> Premier Partner mı yoksa standard Partner mı?",
        "<strong>Badge Expiry:</strong> Badge'in son yenilenme tarihi güncel mi?"
      ]
    },
    {
      type: "subheading",
      value: "2. Sertifikalar ve Ekip Uzmanlığı"
    },
    {
      type: "list",
      items: [
        "<strong>Sertifikalı Uzman Sayısı:</strong> Kaç kişi Google Ads sertifikalı? (1 minimum, 5+ ideal)",
        "<strong>Sertifika Tipleri:</strong> Search, Display, Video, Shopping, Apps - hangileri var?",
        "<strong>Ekip Deneyimi:</strong> Hesabınızı yönetecek kişinin tecrübesi kaç yıl?",
        "<strong>Specialization:</strong> Sizin sektörünüzde uzman var mı?",
        "<strong>Turnover:</strong> Ekip değişim oranı düşük mü?"
      ]
    },
    {
      type: "subheading",
      value: "3. Sektör Deneyimi ve Case Study'ler"
    },
    {
      type: "list",
      items: [
        "<strong>Sektör Portfolio:</strong> Sizin sektörünüzde daha önce çalışmış mı?",
        "<strong>Benzer Bütçe:</strong> Sizin bütçenize benzer müşterileri var mı?",
        "<strong>Case Study:</strong> Somut sonuçlar gösteren vaka çalışmaları paylaşabilir mi?",
        "<strong>Referanslar:</strong> Mevcut veya geçmiş müşterilerle konuşabilir misiniz?",
        "<strong>Success Metrics:</strong> Ortalama ROAS, CPA improvement gibi metrikler neler?"
      ]
    },
    {
      type: "subheading",
      value: "4. Hizmet Kalitesi ve Süreç"
    },
    {
      type: "list",
      items: [
        "<strong>Response Time:</strong> Ne kadar hızlı yanıt alırsınız? (24 saat ideal)",
        "<strong>Dedicated Account Manager:</strong> Size özel bir yönetici atanacak mı?",
        "<strong>Raporlama Sıklığı:</strong> Haftalık mı aylık mı?",
        "<strong>Toplantı Frequency:</strong> Ne sıklıkla strateji toplantısı?",
        "<strong>Optimization Process:</strong> Ne kadar sık optimizasyon yapılıyor?"
      ]
    },
    {
      type: "subheading",
      value: "5. Şeffaflık ve Hesap Erişimi"
    },
    {
      type: "list",
      items: [
        "<strong>KIRHICI ÖNEMLI:</strong> Google Ads hesabının sahibi SİZ olmalısınız",
        "<strong>Admin Access:</strong> Size tam admin erişimi verecekler mi?",
        "<strong>Data Ownership:</strong> Tüm data ve assets size ait mi?",
        "<strong>Transparency:</strong> Tüm kampanya detaylarını görebiliyor musunuz?",
        "<strong>Exit Strategy:</strong> Ayrılmak isterseniz kampanyalar nasıl transfer edilir?"
      ]
    },
    {
      type: "subheading",
      value: "6. Maliyet ve Sözleşme Koşulları"
    },
    {
      type: "list",
      items: [
        "<strong>Fiyatlandırma Modeli:</strong> Sabit fee mi, yüzdesel mi, hibrit mi?",
        "<strong>Minimum Sözleşme:</strong> 3-6 ay makul (1+ yıl uzun olabilir)",
        "<strong>Fesih Koşulları:</strong> 30 gün önceden bildirim standardı",
        "<strong>Hidden Costs:</strong> Setup fee, additional services için ek ücretler var mı?",
        "<strong>Performance Guarantees:</strong> Gerçekçi hedefler ve garanti şartları neler?"
      ]
    },
    { type: "heading", value: "Google Partner Olma Süreci ve Gereksinimleri", id: "sertifikasyon" },
    {
      type: "paragraph",
      value: "Bir ajans veya uzmanın Google Partner olabilmesi için adım adım süreç:"
    },
    {
      type: "subheading",
      value: "Adım 1: Skillshop Hesabı ve Sertifikasyon"
    },
    {
      type: "list",
      items: [
        "<strong>Skillshop Kayıt:</strong> skillshop.exceedlms.com adresinden ücretsiz hesap açın",
        "<strong>Sertifika Sınavları:</strong> Google Ads sertifika sınavlarından en az birini geçin",
        "<strong>Available Certifications:</strong> Search, Display, Video, Shopping, Apps, Measurement",
        "<strong>Exam Format:</strong> Multiple choice, 45-75 dakika, passing score %80",
        "<strong>Renewal:</strong> Her sertifika 1 yıl geçerli, yeniden sınava girme gerekir"
      ]
    },
    {
      type: "subheading",
      value: "Adım 2: Google Ads Manager Hesabı (MCC)"
    },
    {
      type: "list",
      items: [
        "<strong>MCC Account:</strong> Manager hesabı oluşturun (ads.google.com/home/tools/manager-accounts/)",
        "<strong>Link Client Accounts:</strong> Müşteri hesaplarını MCC'ye bağlayın",
        "<strong>Requirements:</strong> En az 1 aktif client hesap gerekli",
        "<strong>Organization Setup:</strong> Şirket bilgilerini ekleyin"
      ]
    },
    {
      type: "subheading",
      value: "Adım 3: Performance Requirements Karşılanması"
    },
    {
      type: "list",
      items: [
        "<strong>Ad Spend:</strong> Son 90 günde toplam $10,000+ managed spend (Premier için $150,000+)",
        "<strong>Optimization Score:</strong> Portfolio ortalaması %70+ olmalı",
        "<strong>Growth:</strong> Müşteri hesaplarında sürdürülebilir büyüme gösterimi",
        "<strong>Retention:</strong> En az %50 müşteri retention oranı",
        "<strong>Best Practices:</strong> Google'ın best practices'larını takip etme"
      ]
    },
    {
      type: "subheading",
      value: "Adım 4: Partner Program Başvurusu"
    },
    {
      type: "list",
      items: [
        "<strong>Application:</strong> Google Partners programına başvuru (partners.google.com)",
        "<strong>Company Profile:</strong> Şirket bilgileri, sektör, hizmetler",
        "<strong>Link Skillshop:</strong> Sertifika hesabınızı company profile'a bağlayın",
        "<strong>Review Process:</strong> Google tarafından başvuru incelemesi (1-2 hafta)",
        "<strong>Badge Activation:</strong> Onay sonrası badge aktifleştirilir"
      ]
    },
    {
      type: "subheading",
      value: "Adım 5: Specialization Badges (İsteğe Bağlı)"
    },
    {
      type: "paragraph",
      value: "Partner olduktan sonra specialization badges için başvurabilirsiniz. Her badge için ayrı kriterler:"
    },
    {
      type: "table",
      caption: "Specialization Badge Gereksinimleri",
      headers: ["Badge", "90-Day Spend", "Performance", "Certified Experts"],
      rows: [
        ["<strong>Search Advertising</strong>", "$5,000+", "%5+ CTR", "1+"],
        ["<strong>Display Advertising</strong>", "$2,500+", "Industry benchmarks", "1+"],
        ["<strong>Video Advertising</strong>", "$2,500+", "Industry benchmarks", "1+"],
        ["<strong>Shopping Advertising</strong>", "$5,000+", "Industry benchmarks", "1+"],
        ["<strong>Apps Advertising</strong>", "$2,500+", "Industry benchmarks", "1+"]
      ]
    },
    {
      type: "subheading",
      value: "Adım 6: Badge Maintenance (Yıllık Yenileme)"
    },
    {
      type: "list",
      items: [
        "<strong>Annual Renewal:</strong> Her yıl performans kriterleri yeniden değerlendirilir",
        "<strong>Continuous Requirements:</strong> Spend, optimization score, retention sürekli takip edilir",
        "<strong>Certification Renewal:</strong> Sertifikaların yenilenmesi gerekir (1 yıl geçerli)",
        "<strong>Badge Loss:</strong> Kriterleri karşılayamazsa badge kaybedilebilir",
        "<strong>Re-application:</strong> Badge kaybedilirse 3 ay sonra yeniden başvurabilirsiniz"
      ]
    },
    { type: "heading", value: "Premier Partner vs Standard Partner: Hangi Fark Eder?", id: "premier-partner" },
    {
      type: "paragraph",
      value: "Premier Partner badge almak, bir ajansın en üst seviye performans ve uzmanlığa sahip olduğunu gösterir. İşte farklar:"
    },
    {
      type: "subheading",
      value: "Premier Partner'ın Ek Avantajları"
    },
    {
      type: "list",
      items: [
        "<strong>Priority Google Support:</strong> Google temsilcilerine öncelikli ve daha hızlı erişim",
        "<strong>Beta Features:</strong> Yeni özeliklere ilk erişim (Standard Partner'dan önce)",
        "<strong>Executive Events:</strong> Google'ın exclusive eventlerine davet",
        "<strong>Co-Marketing:</strong> Google ile ortak pazarlama fırsatları",
        "<strong>Case Study Support:</strong> Google'ın case study hazırlama desteği",
        "<strong>Advanced Training:</strong> Özel eğitim programları ve workshoplar",
        "<strong>Prestige:</strong> Piyasada daha yüksek kredibilite ve güven"
      ]
    },
    {
      type: "subheading",
      value: "Premier Partner Olmak İçin Gereken Şartlar"
    },
    {
      type: "list",
      items: [
        "<strong>90-Day Spend:</strong> $150,000+ managed ad spend (Partner'da $10,000)",
        "<strong>Certified Experts:</strong> En az 2 Google Ads sertifikalı uzman (Partner'da 1)",
        "<strong>Optimization Score:</strong> %70+ (aynı)",
        "<strong>Specialization:</strong> En az 1 specialization badge (önerilen)",
        "<strong>Company Size:</strong> Genellikle orta-büyük ajanslar (küçük ajanslar zor ulaşır)"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>Müşteri Açısından:</strong> Premier Partner badge, ajansın büyüklüğünü ve deneyimini gösterir ama her zaman daha iyi hizmet anlamına gelmez. KOBİ'ler için Standard Partner bile yeterli olabilir. <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">18 yıllık deneyimimle</a> gözlemlediğim kadarıyla, orta ölçekli işletmeler için deneyimli bir bireysel Google Partner uzman, büyük Premier Partner ajanslardan daha kişiselleştirilmiş ve etkili hizmet sunabilir."
    },
    { type: "heading", value: "Google Partner Statüsünü Doğrulama", id: "dogrulama" },
    {
      type: "paragraph",
      value: "Bir ajansın gerçekten Google Partner olup olmadığını doğrulamak için:"
    },
    {
      type: "subheading",
      value: "1. Google Partners Directory Kontrolü"
    },
    {
      type: "list",
      items: [
        "<strong>Adım 1:</strong> partners.google.com adresine gidin",
        "<strong>Adım 2:</strong> 'Find a Partner' bölümünden ajansı arayın",
        "<strong>Adım 3:</strong> Şirket adını veya websitesini girin",
        "<strong>Adım 4:</strong> Partner badge'ini ve specialization badges'leri kontrol edin",
        "<strong>Adım 5:</strong> Ajansın hizmet alanlarını, lokasyonunu ve iletişim bilgilerini doğrulayın"
      ]
    },
    {
      type: "subheading",
      value: "2. Ajans Websitesinde Badge Kontrolü"
    },
    {
      type: "list",
      items: [
        "<strong>Partner Badge:</strong> Ajansın websitesinde resmi Google Partner badge olmalı",
        "<strong>Badge Rengi:</strong> Mavi (Standard Partner) veya Kırmızı (Premier Partner)",
        "<strong>Specialization Badges:</strong> Varsa specialization badges'leri gösterilmeli",
        "<strong>Clickable Badge:</strong> Badge tıklanabilir ve Google Partners directory'ye yönlendirmeli",
        "<strong>Current Badge:</strong> Badge güncel mi? (yıl bilgisini kontrol edin)"
      ]
    },
    {
      type: "subheading",
      value: "3. Sorulması Gereken Sorular"
    },
    {
      type: "list",
      items: [
        "❓ 'Google Partner mısınız? Premier Partner mı yoksa Standard Partner mı?'",
        "❓ 'Hangi specialization badges'leriniz var?'",
        "❓ 'Kaç tane Google Ads sertifikalı uzmanınız var?'",
        "❓ 'Partner badge'inizi Google Partners directory'den görebilir miyim?'",
        "❓ 'Son 90 günde yönettiğiniz toplam ad spend ne kadar?' (doğrudan soramazsınız ama dolaylı anlayabilirsiniz)",
        "❓ 'Google temsilcinizle düzenli iletişiminiz var mı?'"
      ]
    },
    {
      type: "subheading",
      value: "🚩 Sahte Partner Badge Red Flags"
    },
    {
      type: "list",
      items: [
        "❌ Badge var ama Google Partners directory'de bulamıyorsunuz",
        "❌ Badge'in üzerine tıklayamıyorsunuz veya dead link",
        "❌ Badge eski (yıl bilgisi 2-3 yıl öncesine ait)",
        "❌ 'Google Partner'ız' diyorlar ama badge göstermiyorlar",
        "❌ 'Google ile çalışıyoruz' diyorlar ama Partner değiller (herkes Google ile çalışır)"
      ]
    },
    {
      type: "paragraph",
      value: "<strong>UYARI:</strong> 'Google Certified' veya 'Google Approved' gibi terimler Partner badge'den farklıdır. Resmi statü 'Google Partner' veya 'Premier Partner' olmalıdır."
    },
    {
      type: "paragraph",
      value: "<strong>Sonuç:</strong> Google Partner badge, bir ajansın Google Ads uzmanlığını ve performansını doğrulayan önemli bir göstergedir. Ancak, badge tek başına yeterli değildir. Ajansın sektör deneyimi, case study'leri, iletişim kalitesi ve maliyet-performans dengesi de değerlendirilmelidir. <a href=\"/\" class=\"text-[#059669] font-bold hover:underline\">Ben, 18 yıllık Google Ads deneyimi ile Google Partner sertifikalı uzman olarak bireysel danışmanlık sunuyorum.</a> Hem Partner badge'in avantajlarından hem de bireysel uzmanın kişiselleştirilmiş yaklaşımından faydalanabilirsiniz. İletişime geçin, işletmeniz için en doğru stratejiyi birlikte oluşturalım."
    }
  ]
};

export default googlePartnerAjansContent;
